module.exports = __webpack_public_path__ + "img/airports.5b83425a.svg";